
import { Component, Prop } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CardBody from '@/components/card-body/index.vue'
import WorkingZone from '@/entities/workzone'
import User from '@/entities/user'
import dayjs from 'dayjs'

@Component({
  components: { CardBody }
})
export default class WorkingZoneDetailEdit extends AbpBase {
  /**
   * 组件名称
   */
  name: string = 'WorkingZone Edit'

  workingzone: WorkingZone = new WorkingZone()

  workingzonetypes: Array<any> = 
  [
      {
        value: 'Store',
        label: 'Store'
      },
      {
        value: 'Warehouse',
        label: 'Warehouse'
      },
  ]

  rules = {
    workingZone: [
      {
        required: true,
        message: 'Please input Working Zone',
        trigger: 'blur'
      }
    ],
    locCode: [
      {
        required: true,
        message: 'Please input Location Code',
        trigger: 'blur'
      }
    ],
    name: [
      {
        required: true,
        message: 'Please input Location Name',
        trigger: 'blur'
      }
    ],
    type: [
      {
        required: true,
        message: 'Please select Type',
        trigger: 'change'
      }
    ]
  }

  appRoleList: Array<User> = []

  async getAppRoles() {
    let res = await this.$store.dispatch({
      type: 'user/getAllAppRole'
    })
    this.appRoleList = (res || []).map(t => {
      return {
        label: t.userName,
        value: t.id
      }
    })
  }

  // 新建或更新
  doCreateOrUpdate() {
    ;(this.$refs.form as any).validate(async (valid: boolean) => {
      if (!valid) {
        return
      }
      this.createOrUpdateWorkingZone({
        workingzone: this.workingzone
      })
    })
  }
  // 调用接口
  async createOrUpdateWorkingZone(data) {
    await this.$store.dispatch({
      type: 'workingzone/createOrUpdateWorkingZone',
      data: data
    })
    this.$notify.success({
      title: 'Success',
      message: 'Save Success'
    })
    this.doCancel()
  }

  doCancel() {
    ;(this.$refs.form as any).resetFields()
    this.$router.back()
  }

  loading = false

  async created() {
    try {
      this.loading = true
      this.getAppRoles()
      let id = +this.$route.params.id
      if (!id || id < 0) {
        // 新增
        return
      }
      // 编辑
      this.workingzone.id = +id
      let res = await this.$store.dispatch({
        type: 'workingzone/get',
        id: this.$route.params.id
      })
      this.workingzone = res.workingZone
    } catch (e) {
      console.log(e);
    } finally{
      this.loading = false
    }
  }
}
